"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto" };
const _hoisted_2 = { class: "text-2xl pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = { class: "text-xl pl-5 my-5 font-bold uppercase" };
const _hoisted_4 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_7 = { class: "text-xl pl-5 my-5 font-bold uppercase" };
const _hoisted_8 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-remove" }, null, -1);
const _hoisted_11 = { class: "flex flex-col md:flex-row my-3" };
const _hoisted_12 = { class: "flex grow w-auto md:justify-end md:pr-3.5 mx-3" };
const _hoisted_13 = { class: "p-4 mb-5 flex bg-white border border-gray rounded shadow" };
const _hoisted_14 = { class: "w-1/2" };
const _hoisted_15 = { class: "font-bold mb-3 underline underline-offset-8" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "w-1/2 text-right" };
const _hoisted_18 = {
    key: 0,
    class: "font-bold mb-3 underline underline-offset-8"
};
const _hoisted_19 = {
    key: 1,
    class: "font-bold mb-3 underline underline-offset-8"
};
const _hoisted_20 = { class: "flex mt-[60px]" };
const _hoisted_21 = { class: "w-1/3 flex" };
const _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-1/3" }, null, -1);
const _hoisted_23 = { class: "w-1/3" };
const _hoisted_24 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full border-b-1 border-black h-[25px]" }, null, -1);
const _hoisted_25 = {
    key: 0,
    class: "w-full text-center"
};
const _hoisted_26 = { class: "flex flex-col lg:flex-row mt-3 no-print" };
const _hoisted_27 = { class: "lg:grow text-left flex justify-start" };
const _hoisted_28 = { class: "lg:grow text-right flex justify-end" };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const ProductDataForm_vue_1 = __importDefault(require("./ProductDataForm.vue"));
const CustomerDataForm_vue_1 = __importDefault(require("./CustomerDataForm.vue"));
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const customerProductReturnStore_1 = require("../../stores/customerProductReturn/customerProductReturnStore");
const CustomerProductReturnCreateRequest_1 = require("../../stores/customerProductReturn/CustomerProductReturnCreateRequest");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Form_1 = require("../../components/Form");
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const axaptaCustomerProductReturnStore_1 = require("../../stores/axaptaCustomerProductReturn/axaptaCustomerProductReturnStore");
const shop_1 = require("../../common/utils/shop");
const CustomerProductReturnReasonCodes_1 = require("../../stores/customerProductReturn/CustomerProductReturnReasonCodes");
const CustomerProductReturnShippingModes_1 = require("../../stores/customerProductReturn/CustomerProductReturnShippingModes");
const salesContactsStore_1 = require("../../stores/salesContacts/salesContactsStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CustomerProductReturn',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const successfulSubmissionModalIsOpen = (0, vue_3.ref)(false);
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const salesContactsStore = (0, salesContactsStore_1.useSalesContactsStore)();
        const customerProductReturnStore = (0, customerProductReturnStore_1.useCustomerProductReturnStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const customerProductReturnCreateRequest = (0, vue_3.ref)(new CustomerProductReturnCreateRequest_1.CustomerProductReturnCreateRequest());
        const axaptaCustomerProductReturnStore = (0, axaptaCustomerProductReturnStore_1.useAxaptaCustomerProductReturnStore)();
        let axaptaID = (0, vue_3.ref)("");
        const dotNumberLength = (0, vue_3.ref)(4);
        const selectedReasonOption = (reasonCode) => {
            for (const reasonCodeOption of reasonCodeOptions.value) {
                if (reasonCodeOption.value == reasonCode) {
                    return reasonCodeOption.text;
                }
            }
            return "";
        };
        const reasonCodeOptions = (0, vue_3.ref)([
            new Option_1.default(0, (0, i18n_1.trans)("choose_reason", "Choose a reason", "customer_product_return"), true),
            new Option_1.default(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_DELIVERY, (0, i18n_1.trans)("reason_wrong_delivery", "Wrong delivery", "customer_product_return"), ((_a = customerProductReturnCreateRequest.value) === null || _a === void 0 ? void 0 : _a.reasonCode) ==
                CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_DELIVERY),
            new Option_1.default(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_ORDER, (0, i18n_1.trans)("reason_wrong_order", "Wrong order", "customer_product_return"), ((_b = customerProductReturnCreateRequest.value) === null || _b === void 0 ? void 0 : _b.reasonCode) ==
                CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_ORDER),
            new Option_1.default(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_DOT, (0, i18n_1.trans)("reason_wrong_dot", "Wrong DOT", "customer_product_return"), ((_c = customerProductReturnCreateRequest.value) === null || _c === void 0 ? void 0 : _c.reasonCode) ==
                CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_DOT),
            new Option_1.default(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.OTHER, (0, i18n_1.trans)("reason_other", "Other - reason in note", "customer_product_return"), ((_d = customerProductReturnCreateRequest.value) === null || _d === void 0 ? void 0 : _d.reasonCode) ==
                CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.OTHER),
        ]);
        const customerProductReturnListFields = (0, vue_3.ref)([
            {
                key: "invoiceId",
                label: (_e = (0, i18n_1.trans)("invoice_id", "Invoice ID", "customer_product_return")) !== null && _e !== void 0 ? _e : "Invoice ID",
                value: "InvoiceId",
            },
            {
                key: "productId",
                label: (_f = (0, i18n_1.trans)("item_id", "Product ID", "customer_product_return")) !== null && _f !== void 0 ? _f : "Product ID",
                value: "ProductId",
            },
            {
                key: "productName",
                label: (_g = (0, i18n_1.trans)("item_name", "Product Name", "customer_product_return")) !== null && _g !== void 0 ? _g : "Product Name",
                value: "productName",
            },
            {
                key: "creditableQuantity",
                label: (_h = (0, i18n_1.trans)("creditable_quantity", "Creditable quantity", "customer_product_return")) !== null && _h !== void 0 ? _h : "Creditable Quantity",
                value: "creditableQuantity",
            },
            {
                key: "quantity",
                label: (_j = (0, i18n_1.trans)("quantity", "Quantity", "customer_product_return")) !== null && _j !== void 0 ? _j : "Quantity",
            },
            {
                key: "dotNumber",
                label: (_k = (0, i18n_1.trans)("dot_number", "Dot number", "customer_product_return")) !== null && _k !== void 0 ? _k : "Dot number",
            },
            {
                key: "reasonCode",
                label: (_l = (0, i18n_1.trans)("reason_code", "Reason code", "customer_product_return")) !== null && _l !== void 0 ? _l : "Reason code",
            },
            {
                key: "reasonMessage",
                label: (_m = (0, i18n_1.trans)("reason_message", "Reason message", "customer_product_return")) !== null && _m !== void 0 ? _m : "Reason message",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const deleteItem = (request) => {
            axaptaCustomerProductReturnStore.addProductItem(request);
            customerProductReturnStore.removeSubmittedProductItem(request);
        };
        const addItem = (request) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!request.quantity) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_quantity", "Quantity required!", "customer_product_return")) !== null && _a !== void 0 ? _a : "Quantity required!");
                return false;
            }
            if (!request.reasonCode) {
                toastStore.addErrorToast((_b = (0, i18n_1.trans)("no_reason_code", "Reason code required!", "customer_product_return")) !== null && _b !== void 0 ? _b : "Reason code required!");
                return false;
            }
            if (request.quantity <= 0) {
                toastStore.addErrorToast((_c = (0, i18n_1.trans)("quantity_null", "Min quantity is 1", "customer_product_return")) !== null && _c !== void 0 ? _c : "Min quantity is 1");
                return false;
            }
            if (request.creditableQuantity < request.quantity) {
                toastStore.addErrorToast((_d = (0, i18n_1.trans)("creditable_quantity_less_than_quantity", "Creditable quantity is less than quantity!", "customer_product_return")) !== null && _d !== void 0 ? _d : "Creditable quantity is less than quantity!");
                return false;
            }
            if (request.reasonCode === CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.OTHER &&
                request.reasonMessage == "") {
                toastStore.addErrorToast((_e = (0, i18n_1.trans)("no_reason_message", "Reason message required!", "customer_product_return")) !== null && _e !== void 0 ? _e : "Reason message required!");
                return false;
            }
            if (request.reasonCode === CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.WRONG_DOT &&
                request.dotNumber == "") {
                toastStore.addErrorToast((_f = (0, i18n_1.trans)("no_dot_number", "DOT number required!", "customer_product_return")) !== null && _f !== void 0 ? _f : "DOT number required!");
                return false;
            }
            request.reasonCodeText = selectedReasonOption((_g = request.reasonCode) !== null && _g !== void 0 ? _g : CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes.OTHER);
            axaptaCustomerProductReturnStore.removeProductItem(request);
            customerProductReturnStore.addProductItem(request);
        };
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let fifteenDaysBeforeToday = new Date();
            fifteenDaysBeforeToday.setDate(fifteenDaysBeforeToday.getDate() - 15);
            return (0, shop_1.formatDate)(fifteenDaysBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
        });
        (0, vue_3.onBeforeMount)(() => {
            customerProductReturnCreateRequest.value =
                new CustomerProductReturnCreateRequest_1.CustomerProductReturnCreateRequest();
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            axaptaCustomerProductReturnStore
                .getCustomerProductReturns(router, filter.value, securityStore.authenticatedUser.customer.id)
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        });
        (0, vue_3.watch)(() => successfulSubmissionModalIsOpen.value, (value) => {
            if (!value) {
                window.location.reload();
            }
        });
        (0, vue_3.watchEffect)(() => {
            if (securityStore.authenticatedUser === null) {
                return;
            }
            customerProductReturnCreateRequest.value.customer = securityStore.authenticatedUser
                .customer.iri;
        });
        const salesContacts = (0, vue_3.computed)(() => salesContactsStore.salesContacts);
        (0, vue_3.watchEffect)(() => {
            if (securityStore.authenticatedUser !== null) {
                salesContactsStore.getCustomerSalesContacts(router, securityStore.authenticatedUser.departmentDeep);
            }
        });
        const printPage = () => {
            // Ezekre a sorokra a DEV-2741 task megoldásához volt szükség.
            // A nyomtatási nézetben duplázódtak az elemek, ez a két style tulajdonság megoldotta a problémát.
            // A tulajdonságokat nem kell levenni a html-ről a print után, mert a modalból kilépve az oldal újratöltődik.
            let html = document.querySelector('html');
            if (html) {
                html.style.height = "100%";
                html.style.overflow = "hidden";
            }
            let body = document.querySelector('body');
            if (body) {
                body.style.height = "100%";
                body.style.overflow = "hidden";
            }
            window.print();
        };
        const refreshPage = () => {
            window.location.reload();
        };
        const submit = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            let deliveryAddress;
            if (!customerProductReturnCreateRequest.value.shippingMode) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_shipping_mode", "Shipping mode required!", "customer_product_return")) !== null && _a !== void 0 ? _a : "Shipping mode required!");
                return false;
            }
            if (customerProductReturnCreateRequest.value.shippingMode ==
                CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes.DELIVERY &&
                customerProductReturnCreateRequest.value.customerEqualsEndUser) {
                if (!customerProductReturnCreateRequest.value.shippingAddress) {
                    toastStore.addErrorToast((_b = (0, i18n_1.trans)("no_delivery_address", "Shipping address required!", "customer_product_return")) !== null && _b !== void 0 ? _b : "Shipping address required!");
                    return false;
                }
                deliveryAddress =
                    customerProductReturnCreateRequest.value.shippingAddress.split("-");
                if (deliveryAddress) {
                    customerProductReturnCreateRequest.value.shippingZip =
                        deliveryAddress[0];
                    customerProductReturnCreateRequest.value.shippingCity =
                        deliveryAddress[1];
                    customerProductReturnCreateRequest.value.shippingStreet =
                        deliveryAddress[2];
                }
            }
            if (customerProductReturnCreateRequest.value.shippingMode ==
                CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes.DELIVERY &&
                !customerProductReturnCreateRequest.value.customerEqualsEndUser) {
                if (!customerProductReturnCreateRequest.value.transferName) {
                    toastStore.addErrorToast((_c = (0, i18n_1.trans)("no_transfer_name", "Transfer name required!", "customer_product_return")) !== null && _c !== void 0 ? _c : "Transfer name required!");
                    return false;
                }
                if (!customerProductReturnCreateRequest.value.transferPhone) {
                    toastStore.addErrorToast((_d = (0, i18n_1.trans)("no_transfer_phone", "Transfer phone required!", "customer_product_return")) !== null && _d !== void 0 ? _d : "Transfer phone required!");
                    return false;
                }
                if (!customerProductReturnCreateRequest.value.shippingZip &&
                    !customerProductReturnCreateRequest.value.shippingCity &&
                    !customerProductReturnCreateRequest.value.shippingStreet) {
                    toastStore.addErrorToast((_e = (0, i18n_1.trans)("no_address", "Delivery address required!", "customer_product_return")) !== null && _e !== void 0 ? _e : "Delivery address required!");
                    return false;
                }
            }
            if (!customerProductReturnStore.submittedProductReturns.length) {
                toastStore.addErrorToast((_f = (0, i18n_1.trans)("no_submitted_items", "Submitted product is required!", "customer_product_return")) !== null && _f !== void 0 ? _f : "Submitted product is required!");
                return false;
            }
            const customerData = {
                accountNum: securityStore.authenticatedUser.customer.id,
                transferName: customerProductReturnCreateRequest.value.transferName,
                customerEqualsEndUser: customerProductReturnCreateRequest.value.customerEqualsEndUser,
                transferPhone: customerProductReturnCreateRequest.value.transferPhone,
                shippingMode: customerProductReturnCreateRequest.value.shippingMode,
                shippingZip: customerProductReturnCreateRequest.value.customerEqualsEndUser &&
                    customerProductReturnCreateRequest.value.shippingMode == 2
                    ? deliveryAddress[0]
                    : (_g = customerProductReturnCreateRequest.value) === null || _g === void 0 ? void 0 : _g.shippingZip,
                shippingCity: customerProductReturnCreateRequest.value.customerEqualsEndUser &&
                    customerProductReturnCreateRequest.value.shippingMode == 2
                    ? deliveryAddress[1]
                    : (_h = customerProductReturnCreateRequest.value) === null || _h === void 0 ? void 0 : _h.shippingCity,
                shippingStreet: customerProductReturnCreateRequest.value.customerEqualsEndUser &&
                    customerProductReturnCreateRequest.value.shippingMode == 2
                    ? deliveryAddress[2]
                    : (_j = customerProductReturnCreateRequest.value) === null || _j === void 0 ? void 0 : _j.shippingStreet,
                contactName: securityStore.authenticatedUser.customer.contactName,
                contactPhone: securityStore.authenticatedUser.customer.contactPhone,
            };
            axaptaCustomerProductReturnStore
                .createCustomerProductReturns(router, customerData, customerProductReturnStore.submittedProductReturns)
                .then(() => {
                let emails = [];
                salesContacts.value.forEach((item) => {
                    if (item.jobCategory === "Asszisztens") {
                        emails.push(item.email);
                    }
                });
                customerProductReturnStore.createCustomerProductReturns(router, axaptaCustomerProductReturnStore.axaptaId, customerData, customerProductReturnStore.submittedProductReturns);
                axaptaCustomerProductReturnStore.sendCustomerProductReturnCopyInEmail(router, {
                    emails: emails,
                    axaptaId: axaptaCustomerProductReturnStore.axaptaId,
                })
                    .then(() => {
                    axaptaID = axaptaCustomerProductReturnStore.axaptaId;
                    successfulSubmissionModalIsOpen.value = true;
                })
                    .catch((error) => {
                    toastStore.addErrorToast(error.toString());
                });
            })
                .catch((error) => {
                toastStore.addErrorToast(error.toString());
            });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("create_customer_product_return_title", "Create Customer Product Return", "customer_product_return")), 1),
                (0, vue_2.createVNode)(CustomerDataForm_vue_1.default, {
                    "customer-product-return-create-request": customerProductReturnCreateRequest.value
                }, null, 8, ["customer-product-return-create-request"]),
                (0, vue_2.createVNode)(ProductDataForm_vue_1.default, {
                    "customer-product-return-create-request": customerProductReturnCreateRequest.value
                }, null, 8, ["customer-product-return-create-request"]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_product_return_list_title", "Product list", "customer_product_return")), 1),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: customerProductReturnListFields.value,
                    "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((customerProductReturnListFields).value = $event)),
                    items: (0, vue_2.unref)(axaptaCustomerProductReturnStore).axaptaCustomerProductReturns,
                    striped: "",
                    condensed: "",
                    panel: ""
                }, {
                    "cell-quantity": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            class: "text-center",
                            type: "number",
                            border: "",
                            required: "",
                            max: productRequest.creditableQuantity,
                            min: 1,
                            modelValue: productRequest.quantity,
                            "onUpdate:modelValue": ($event) => ((productRequest.quantity) = $event),
                            valid: customerProductReturnCreateRequest.value.isReasonMessageValid(),
                            "show-validity": !productRequest.quantity || productRequest.creditableQuantity < productRequest.quantity
                        }, null, 8, ["max", "modelValue", "onUpdate:modelValue", "valid", "show-validity"])
                    ]),
                    "cell-dotNumber": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            type: "text",
                            "max-length": dotNumberLength.value,
                            border: "",
                            modelValue: productRequest.dotNumber,
                            "onUpdate:modelValue": ($event) => ((productRequest.dotNumber) = $event),
                            valid: customerProductReturnCreateRequest.value.isDOTNumberValid(),
                            "show-validity": productRequest.reasonCode == (0, vue_2.unref)(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes).WRONG_DOT && (productRequest.dotNumber == null || !productRequest.dotNumber),
                            required: ""
                        }, null, 8, ["max-length", "modelValue", "onUpdate:modelValue", "valid", "show-validity"])
                    ]),
                    "cell-reasonCode": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                            modelValue: productRequest.reasonCode,
                            "onUpdate:modelValue": ($event) => ((productRequest.reasonCode) = $event),
                            valid: customerProductReturnCreateRequest.value.isReasonCodeValid(),
                            "show-validity": productRequest.reasonCode == null || productRequest.reasonCode == 0,
                            options: reasonCodeOptions.value
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "valid", "show-validity", "options"])
                    ]),
                    "cell-reasonMessage": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            type: "text",
                            modelValue: productRequest.reasonMessage,
                            "onUpdate:modelValue": ($event) => ((productRequest.reasonMessage) = $event),
                            valid: customerProductReturnCreateRequest.value.isReasonMessageValid(),
                            "show-validity": productRequest.reasonCode == (0, vue_2.unref)(CustomerProductReturnReasonCodes_1.CustomerProductReturnReasonCodes).OTHER && (productRequest.reasonMessage == null || productRequest.reasonMessage == ''),
                            border: "",
                            required: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "valid", "show-validity"])
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (addItem(productRequest))
                            }, [
                                _hoisted_6,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_customer_product_item", "Add", "customer_product_return")), 1)
                            ], 8, _hoisted_5)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items"]),
                (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submitted_customer_product_return_list_title", "Submitted product list", "customer_product_return")), 1),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: customerProductReturnListFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((customerProductReturnListFields).value = $event)),
                    items: (0, vue_2.unref)(customerProductReturnStore).submittedProductReturns,
                    stripeds: "",
                    condensed: "",
                    panel: ""
                }, {
                    "cell-quantity": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest
                            .quantity), 1)
                    ]),
                    "cell-dotNumber": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest
                            .dotNumber), 1)
                    ]),
                    "cell-reasonCode": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest
                            .reasonCodeText), 1)
                    ]),
                    "cell-reasonMessage": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest
                            .reasonMessage), 1)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: productRequest }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteItem(productRequest))
                            }, [
                                _hoisted_10,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("remove", "Remove", "customer_product_return")), 1)
                            ], 8, _hoisted_9)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items"]),
                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "!py-3 w-full md:w-auto inline-block btn btn-rounded btn-primary",
                            onClick: _cache[2] || (_cache[2] = ($event) => (submit()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit", "Submit", "customer_product_return")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    closeable: false,
                    isOpen: successfulSubmissionModalIsOpen.value,
                    title: (0, vue_2.unref)(i18n_1.trans)('successful_modal_header', 'Customer product return', 'customer_product_return'),
                    widthClasses: "print-height print-margin print-padding print-width",
                    onClose: _cache[6] || (_cache[6] = ($event) => (successfulSubmissionModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => {
                        var _a, _b, _c, _d, _e, _f, _g, _h;
                        return [
                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("supplier", "Supplier", "customer_product_return")), 1),
                                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_16, [
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_a = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _a === void 0 ? void 0 : _a.customer.name), 1),
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_b = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _b === void 0 ? void 0 : _b.customer.zipCode), 1),
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_c = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _c === void 0 ? void 0 : _c.customer.city), 1),
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_d = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _d === void 0 ? void 0 : _d.customer.street), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                    (customerProductReturnCreateRequest.value.shippingMode ==
                                        (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).DELIVERY)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_mode", "Shipping mode: ", "customer_product_return")) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_shipping_mode", "Delivery shipping mode", "customer_product_return")), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (customerProductReturnCreateRequest.value.shippingMode ==
                                        (0, vue_2.unref)(CustomerProductReturnShippingModes_1.CustomerProductReturnShippingModes).TAKE_AWAY)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("shipping_mode", "Shipping mode: ", "customer_product_return")) + ": " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("take_away_shipping_mode", "Takeaway shipping mode", "customer_product_return")), 1))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("div", null, " ID: " + (0, vue_2.toDisplayString)((_e = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _e === void 0 ? void 0 : _e.customer.id), 1),
                                        (0, vue_2.createElementVNode)("div", null, "AXAPTA ID: " + (0, vue_2.toDisplayString)((0, vue_2.unref)(axaptaID)), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_f = customerProductReturnCreateRequest.value.transferName) !== null && _f !== void 0 ? _f : ""), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(customerProductReturnCreateRequest.value.shippingZip), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(customerProductReturnCreateRequest.value.shippingCity), 1),
                                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(customerProductReturnCreateRequest.value.shippingStreet), 1)
                                    ])
                                ])
                            ]),
                            (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                                fields: customerProductReturnListFields.value,
                                "onUpdate:fields": _cache[3] || (_cache[3] = ($event) => ((customerProductReturnListFields).value = $event)),
                                items: (0, vue_2.unref)(customerProductReturnStore).submittedProductReturns,
                                stripeds: "",
                                condensed: "",
                                panel: ""
                            }, {
                                "cell-quantity": (0, vue_2.withCtx)(({ item: productRequest }) => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest.quantity), 1)
                                ]),
                                "cell-dotNumber": (0, vue_2.withCtx)(({ item: productRequest }) => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest.dotNumber), 1)
                                ]),
                                "cell-reasonCode": (0, vue_2.withCtx)(({ item: productRequest }) => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest.reasonCodeText), 1)
                                ]),
                                "cell-reasonMessage": (0, vue_2.withCtx)(({ item: productRequest }) => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(productRequest.reasonMessage), 1)
                                ]),
                                _: 1
                            }, 8, ["fields", "items"]),
                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((_g = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _g === void 0 ? void 0 : _g.customer.city) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(), "short", "hu-HU")), 1)
                                ]),
                                _hoisted_22,
                                (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                    _hoisted_24,
                                    ((0, vue_2.unref)(securityStore).authenticatedUser !== null)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, (0, vue_2.toDisplayString)((_h = (0, vue_2.unref)(securityStore).authenticatedUser) === null || _h === void 0 ? void 0 : _h.customer.name), 1))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "!py-3 w-full lg:w-auto inline-block btn btn-rounded btn-warning",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (printPage()))
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return")), 1)
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                    (0, vue_2.createElementVNode)("button", {
                                        type: "button",
                                        class: "!py-3 w-full lg:w-auto inline-block btn btn-rounded btn-primary",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (refreshPage()))
                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("no_print", "Done", "customer_product_return")), 1)
                                ])
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
